import React, { useContext, useEffect, useState } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import "../../styles/styles.css";
import { useTranslation } from "react-i18next";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";

const VDCMobileDetails = ({ viewportData, isVDCMobileViewer = false }) => {
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const { t } = useTranslation();
  return (
    <>
      <div
        className="viewport-overlay-patient"
        style={{ margin: "0px", padding: "10px", boxSizing: "border-box",width:"100%" }}
      >
        {viewportData && (
          <>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span
                style={{
                  lineHeight: "12px",
                  overflow: "hidden",
                  height: "15px",
                }}
              >
                <span className="viewport-overlay-mobile-value">
                  {viewportData?.patientName}
                </span>
              </span>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  className="viewport-overlay-mobile-value"
                  style={{ lineHeight: "12px", width: "17%" }}
                >
                  {viewportData?.patientAge?.slice(0, 1) === "0"
                    ? viewportData?.patientAge?.slice(1, 3) === "-"
                      ? "-"
                      : viewportData?.patientAge?.slice(1, 3)
                    : viewportData?.patientAge?.slice(0, 3) === "-"
                    ? "-"
                    : viewportData?.patientAge?.slice(0, 3)}
                  {" | "}
                  {viewportData?.patientSex === undefined ||
                  viewportData?.patientSex === null ||
                  viewportData?.patientSex === "-"
                    ? "-"
                    : viewportData?.patientSex === "M"
                    ? t("viewer.overlay.male")
                    : t("viewer.overlay.female")}
                </div>
                  <div
                    style={{
                      lineHeight: "12px",
                      overflow: "hidden",
                      height: "13px",
                      width: "83%",
                      textAlign: "end",
                    }}
                  >
                    <div className="viewport-overlay-mobile-value">
                      {viewportData?.studyDescription === "" ||
                      viewportData?.studyDescription === null ||
                      viewportData?.studyDescription === undefined
                        ? "-"
                        : viewportData?.studyDescription}
                    </div>
                  </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ lineHeight: "12px",width:"62%",overflow:"hidden",height:"15px" }}>
                  <span className="viewport-overlay-mobile-key">P: </span>
                  <span className="viewport-overlay-mobile-value">
                    {viewportData?.patientId}
                  </span>
                </div>
                <div style={{ lineHeight: "15px",width:"36%",overflow:"hidden",height:"15px",textAlign:"end" }}>
                  <span className="viewport-overlay-mobile-value">
                    {getConsistentDateFormat(viewportData?.studyDate)}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ lineHeight: "12px" }}>
                  <span className="viewport-overlay-mobile-key">
                    {t("viewer.overlay.series")}:{" "}
                  </span>
                  <span className="viewport-overlay-mobile-value">
                    {viewportData?.series}
                  </span>
                </div>
                <div style={{ lineHeight: "12px"}}>
                  <span className="viewport-overlay-mobile-value">
                    {viewportData?.modality}
                  </span>
                </div>
              </div>
              <div style={{ lineHeight: "15px",width:"100%",overflow:"hidden",height:"15px",display:"flex",flexDirection:"row" }}>
                <span className="viewport-overlay-key">O: </span>
                <span className="viewport-overlay-value">
                  {viewportData?.orderId}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default VDCMobileDetails;
